import { useState, useEffect, useCallback } from 'react';
import {
  ArrowLeft, Save, Eye, Globe, Upload, Plus, Trash2,
  GripVertical, Image, Video, Music, Calendar, Mail,
  User, Layout, Palette, Settings, ExternalLink, Newspaper, Copy, Quote, Star,
  Briefcase, Users, HelpCircle, MessageSquare, Phone, CheckCircle2, XCircle, AlertTriangle, Link, RefreshCw
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '@/components/ui/select';
import { toast } from 'sonner';
import { cn } from '@/lib/utils';
import api from '@/lib/api';
import CloudinaryUploader, { GalleryUploader } from '@/components/CloudinaryUploader';

export const AboutModuleEditor = ({ data, onChange, siteSlug }) => (
  <div className="space-y-6">
    <div className="space-y-2">
      <Label>Section Title</Label>
      <Input 
        value={data.title || 'About'} 
        onChange={(e) => onChange({...data, title: e.target.value})}
      />
    </div>
    <div className="space-y-2">
      <Label>Profile Image</Label>
      <CloudinaryUploader
        currentImage={data.profile_image}
        currentFocalPoint={data.profile_focal_point}
        onUpload={(url, publicId, focalPoint) => onChange({
          ...data, 
          profile_image: url,
          profile_focal_point: focalPoint
        })}
        onRemove={() => onChange({...data, profile_image: '', profile_focal_point: null})}
        folder={`sites/${siteSlug}/about`}
        aspectRatio="aspect-square"
        placeholder="Drop profile photo here"
        className="max-w-[200px]"
      />
    </div>
    <div className="space-y-2">
      <Label>Bio</Label>
      <Textarea 
        value={data.bio || ''} 
        onChange={(e) => onChange({...data, bio: e.target.value})}
        placeholder="Tell your story..."
        rows={8}
      />
    </div>
  </div>
);

